import React, { useState } from 'react'

import { NumberFieldData } from '../../../mockData/inventory'
import useStyles from './styles/InventoryRoomTypeRowMobile.styles'

interface InventoryRoomtypeRowProps {
  name: string
  pooledAvailability: NumberFieldData[]
}

const InventoryRoomtypeRow: React.FC<InventoryRoomtypeRowProps> = ({
  name,
  pooledAvailability
}) => {
  const classes = useStyles()
  const [hoveredItem, sethoveredItem] = useState<number | null>(null)

  return (
    <div className={classes.roomTypeRow}>
      <div className={classes.avalabilitiesContainer}>
        {pooledAvailability?.map((availItem, index) => (
          <div
            key={`${name}-${availItem.date}`}
            className={[
              classes.dayContainer,
              hoveredItem === index ? classes.selectedDayContainer : ''
            ].join(' ')}>
            <input
              defaultValue={availItem.value}
              onClick={(e) => {
                sethoveredItem(index)
                e.currentTarget.select()
              }}
              onBlur={() => {
                sethoveredItem(null)
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default InventoryRoomtypeRow
